import { toast } from "react-toastify";
import defaultErrorHandler from "api/global/default-error-handler";
import {
    requestMerchandiserGetCharges,
    requestMerchandiserRecentJobs,
    requestMerchandiserGetInvoices,
    requestMerchandiserGetPdfInvoice,
    requestMerchandiserApproveGroup,
    requestSubmitMerchandiserInvoice,
    requestGetMerchandiserChargeById,
    requestMerchandiserupdateMerchandiserCharge,
    requestMerchandiserGetInvoiceByIdForPDF,

    requestCustomerInvoicingCharges,
    requestPatchCustomerChargeBillingHours,

    requestCustomerInvoicingInvoices,
    requestCustomerInvoicingDeleteInvoice,
    requestCustomerGetPdfInvoice,
    requestCustomerGetPdfSummary,
    requestCustomerInvoicingGetInvoiceById,
    requestCustomerInvoicingUpdateInvoiceById,
    requestCustomerSendInvoice,
    requestCustomerSubmitInvoice,
    requestCustomerGenerateInvoice,
    requestCustomerGetCsvSummary,
    requestCustomerGetExcelSummary,
    requestCustomerExportChargesExcel,
    requestGetAccountingServiceInvoices,
    requestExportAccountingServiceInvoices,
    requestExportAccountingClientInvoices,
    requestGetAccountingClientInvoices,
    requestExportAccountingActiveJobs,
    requestGetMissingMerchandiserCharges,
    requestGetMissingClientCharges,
    requestCreateMerchandiserCharges,
    requestCreateClientCharges,
    requestReportExcel,
    requestRecentCompletedServices,
    requestGetAccountingServiceInvoicesBatches,
    requestGetAccountingClientInvoicesBatches,
    requestClientReportExcel,
    requestProcessAutoTravelCharges
} from "api/menu/invoicing/requests";
import exportFromBlob from "../../../helpers/export-from-blob";

export const FETCH_INVOICING_LOADING = "FETCH_INVOICING_LOADING";
export const FETCH_INVOICING_ERROR = "FETCH_INVOICING_ERROR";
export const FETCH_MERCHANDISER_INVOICING_CHARGES_SUCCESS = "FETCH_MERCHANDISER_INVOICING_CHARGES_SUCCESS";
export const FETCH_MERCHANDISER_INVOICING_JOBS_SUCCESS = "FETCH_MERCHANDISER_INVOICING_JOBS_SUCCESS";
export const FETCH_RECENT_COMPLETED_SERVICES_SUCCESS = "FETCH_RECENT_COMPLETED_SERVICES_SUCCESS";
export const FETCH_MERCHANDISER_INVOICING_INVOICES_SUCCESS = "FETCH_MERCHANDISER_INVOICING_INVOICES_SUCCESS";
export const FETCH_MERCHANDISER_INVOICING_BY_CHARGE_ID_SUCCESS = "FETCH_MERCHANDISER_INVOICING_BY_CHARGE_ID_SUCCESS";

export const FETCH_CUSTOMER_INVOICING_CHARGES_SUCCESS = "FETCH_CUSTOMER_INVOICING_CHARGES_SUCCESS";
export const PATCH_CUSTOMER_CHARGES_BILLABLE_HOURS = "PATCH_CUSTOMER_CHARGES_BILLABLE_HOURS";
export const FETCH_CUSTOMER_INVOICING_INVOICES_SUCCESS = "FETCH_CUSTOMER_INVOICING_INVOICES_SUCCESS";
export const DELETE_CUSTOMER_INVOICING_INVOICES_SUCCESS = "DELETE_CUSTOMER_INVOICING_INVOICES_SUCCESS";
export const FETCH_CUSTOMER_INVOICING_INVOICE_BY_ID_SUCCESS = "FETCH_CUSTOMER_INVOICING_INVOICE_BY_ID_SUCCESS";

export const FETCH_ACCOUNTING_SERVICE_INVOICES_SUCCESS = "FETCH_ACCOUNTING_SERVICE_INVOICES_SUCCESS";
export const FETCH_ACCOUNTING_SERVICE_INVOICES_BATCHES_SUCCESS = "FETCH_ACCOUNTING_SERVICE_INVOICES_BATCHES_SUCCESS";
export const FETCH_ACCOUNTING_CLIENT_INVOICES_BATCHES_SUCCESS = "FETCH_ACCOUNTING_CLIENT_INVOICES_BATCHES_SUCCESS";

export const FETCH_ACCOUNTING_CLIENT_INVOICES_SUCCESS = "FETCH_ACCOUNTING_CLIENT_INVOICES_SUCCESS";
export const FETCH_MISSING_MERCHANDISER_CHARGES_SUCCESS = "FETCH_MISSING_MERCHANDISER_CHARGES_SUCCESS";
export const FETCH_MISSING_MERCHANDISER_CHARGES_LOADING = "FETCH_MISSING_MERCHANDISER_CHARGES_LOADING";
export const FETCH_MISSING_CLIENT_CHARGES_SUCCESS = "FETCH_MISSING_CLIENT_CHARGES_SUCCESS";
export const FETCH_MISSING_CLIENT_CHARGES_LOADING = "FETCH_MISSING_CLIENT_CHARGES_LOADING";

export const setLoading = (status) => ({
    type: FETCH_INVOICING_LOADING,
    payload: status
});

export const fetchMerchandiserInvoicingCharges = (options = {}) => dispatch => {
    dispatch(setLoading(true));
        requestMerchandiserGetCharges(options)
            .then(response => {
                dispatch({
                    type: FETCH_MERCHANDISER_INVOICING_CHARGES_SUCCESS,
                    payload: response.data
                });
            })
            .catch(error => {
                dispatch(defaultErrorHandler(error, FETCH_INVOICING_ERROR));
            });
};

export const fetchMerchandiserInvoicingJobs = () => dispatch => {
    dispatch(setLoading(true));
    requestMerchandiserRecentJobs()
        .then((response) => {
            dispatch({
                type: FETCH_MERCHANDISER_INVOICING_JOBS_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_INVOICING_ERROR));
        });
};

export const fetchRecentCompletedServices = (merchandiserId, chargeId) => dispatch => {
    dispatch(setLoading(true));
    requestRecentCompletedServices(merchandiserId, chargeId)
        .then((response) => {
            dispatch({
                type: FETCH_RECENT_COMPLETED_SERVICES_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_INVOICING_ERROR));
        });
};

export const fetchMerchandiserInvoicingInvoices = (options) => dispatch => {
    dispatch(setLoading(true));
    requestMerchandiserGetInvoices(options)
        .then(response => {
            dispatch({
                type: FETCH_MERCHANDISER_INVOICING_INVOICES_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_INVOICING_ERROR));
        });
};

export const fetchMerchandiserPdfInvoice = (options, callback) => dispatch => {
    dispatch(setLoading(true));
    requestMerchandiserGetPdfInvoice(options)
        .then(response => {
            callback(response.data);
            dispatch(setLoading(false));
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_INVOICING_ERROR));
        });
};

export const fetchMerchandiserSingleInvoiceForPDF = (invoiceId, callback) => dispatch => {
    dispatch(setLoading(true));
    requestMerchandiserGetInvoiceByIdForPDF(invoiceId)
        .then(response => {
            callback(response.data);
            dispatch(setLoading(false));
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_INVOICING_ERROR));
        });
};

export const fetchCustomerCsvSummary = (invoiceId, callback) => dispatch => {
    dispatch(setLoading(true));
    requestCustomerGetCsvSummary(invoiceId)
        .then(response => {
            callback(response.data);
            dispatch(setLoading(false));
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_INVOICING_ERROR));
        });
};

export const fetchCustomerExcelSummary = (invoiceId, callback) => dispatch => {
    dispatch(setLoading(true));
    requestCustomerGetExcelSummary(invoiceId)
        .then(response => {
            callback(response.data);
            dispatch(setLoading(false));
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_INVOICING_ERROR));
        });
};


export const approveMerchandiserInvoices = (data, callback) => dispatch => {
    dispatch(setLoading(true));
    requestMerchandiserApproveGroup(data)
        .then(() => {
            toast(`${data.length} charges successfully approved`, {
                type: toast.TYPE.SUCCESS,
            });
            callback();
            dispatch(setLoading(false));
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_INVOICING_ERROR));
            dispatch(setLoading(false));
        });
};

export const submitMerchandiserInvoices = (data, callback) => dispatch => {
    dispatch(setLoading(true));
    requestSubmitMerchandiserInvoice(data)
        .then(() => {
            toast("Invoice submitted successfully", {
                type: toast.TYPE.SUCCESS,
            });
            callback();
            dispatch(setLoading(false));
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_INVOICING_ERROR));
            dispatch(setLoading(false));
        });
};

export const getMerchandiserChargeById = (chargeId) => dispatch => {
    dispatch(setLoading(true));
    requestGetMerchandiserChargeById(chargeId)
        .then(response => {
            dispatch({
                type: FETCH_MERCHANDISER_INVOICING_BY_CHARGE_ID_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(setLoading(false));
            defaultErrorHandler(error);
        });
};

export const resetMerchandiserSingleCharge = () => dispatch => {
    dispatch({
        type: FETCH_MERCHANDISER_INVOICING_BY_CHARGE_ID_SUCCESS,
        payload: {}
    });
};

export const updateMerchandiserCharge = (chargeId, data, callback) => dispatch => {
    dispatch(setLoading(true));
    requestMerchandiserupdateMerchandiserCharge(chargeId, data)
        .then(() => {
            toast(`Charge <${chargeId}> successfully updated`, {
                type: toast.TYPE.SUCCESS,
            });
            callback();
            dispatch(setLoading(false));
        })
        .catch(error => {
            defaultErrorHandler(error);
        });
};

export const fetchCustomerInvoicingCharges = (options = {}) => dispatch => {
    dispatch(setLoading(true));
    requestCustomerInvoicingCharges(options)
        .then(response => {
            dispatch({
                type: FETCH_CUSTOMER_INVOICING_CHARGES_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_INVOICING_ERROR));
        });
};

export const patchCustomerChargeBillingHours = (invoiceSummaryId, billableHours) => dispatch => {
    dispatch(setLoading(true));
    requestPatchCustomerChargeBillingHours(invoiceSummaryId, billableHours)
        .then(response => {
            dispatch({
                type: PATCH_CUSTOMER_CHARGES_BILLABLE_HOURS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_INVOICING_ERROR));
        });
};

export const fetchCustomerInvoicingInvoices = (options = {}) => dispatch => {
    dispatch(setLoading(true));
    requestCustomerInvoicingInvoices(options)
        .then(response => {
            dispatch({
                type: FETCH_CUSTOMER_INVOICING_INVOICES_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_INVOICING_ERROR));
        });
};


export const deleteCustomerInvoicingInvoice = (invoiceId) => dispatch => {
    dispatch(setLoading(true));
    requestCustomerInvoicingDeleteInvoice(invoiceId)
        .then(() => {
            dispatch({
                type: DELETE_CUSTOMER_INVOICING_INVOICES_SUCCESS,
                payload: invoiceId
            });
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, FETCH_INVOICING_ERROR));
        });
};

export const fetchCustomerPdfInvoice = (invoiceId, callback) => dispatch => {
    dispatch(setLoading(true));
    requestCustomerGetPdfInvoice(invoiceId)
        .then(response => {
            callback(response.data);
            dispatch(setLoading(false));
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_INVOICING_ERROR));
        });
};

export const fetchCustomerPdfSummary = (invoiceId, callback) => dispatch => {
    dispatch(setLoading(true));
    requestCustomerGetPdfSummary(invoiceId)
        .then(response => {
            callback(response.data);
            dispatch(setLoading(false));
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_INVOICING_ERROR));
        });
};

export const getCustomerInvoicingInvoiceById = (invoiceId) => dispatch => {
    dispatch(setLoading(true));
    requestCustomerInvoicingGetInvoiceById(invoiceId)
        .then(response => {
            dispatch({
                type: FETCH_CUSTOMER_INVOICING_INVOICE_BY_ID_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, FETCH_INVOICING_ERROR));
        });
};

export const setCustomerInvoicingInvoiceUpdate = (invoiceId, data, callback) => dispatch => {
    dispatch(setLoading(true));
    requestCustomerInvoicingUpdateInvoiceById(invoiceId, data)
        .then(response => {
            dispatch({
                type: FETCH_CUSTOMER_INVOICING_INVOICE_BY_ID_SUCCESS,
                payload: response.data
            });
            toast("Invoice updated successfully", {
                type: toast.TYPE.SUCCESS,
            });
            callback(true);
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, FETCH_INVOICING_ERROR));
        });
};

export const setCustomerInvoicingInvoiceSubmit = (invoiceId, onLoad, onCancel) => dispatch => {
    dispatch(setLoading(true));
    requestCustomerSubmitInvoice(invoiceId)
        .then(response => {
            /*
            dispatch({
                type: FETCH_CUSTOMER_INVOICING_INVOICE_BY_ID_SUCCESS,
                payload: response.data
            });
            */
            toast("Invoice submitted successfully", {
                type: toast.TYPE.SUCCESS,
            });
            dispatch(setLoading(false));
            onLoad();
            onCancel();
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, FETCH_INVOICING_ERROR));
        });
};

export const customerSendInvoice = (invoiceId) => dispatch => {
    dispatch(setLoading(true));
    requestCustomerSendInvoice(invoiceId)
        .then(() => {
            toast("Invoice sent successfully", {
                type: toast.TYPE.SUCCESS,
            });
            dispatch(setLoading(false));
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, FETCH_INVOICING_ERROR));
        });
};

export const customerGenerateInvoice = (data, callback = false) => dispatch => {
    dispatch(setLoading(true));
    requestCustomerGenerateInvoice(data)
        .then(() => {
            dispatch(setLoading(false));
            toast("Preliminary invoice generated successfully", {
                type: toast.TYPE.SUCCESS,
            });
            if (callback) {
                callback();
            }
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, FETCH_INVOICING_ERROR));
        });
};
export const customerExportChargesExcel = (data, callback) => dispatch => {
    dispatch(setLoading(true));
    requestCustomerExportChargesExcel(data)
        .then((response) => {
            dispatch(setLoading(false));
            toast("Charges list exported successfully", {
                type: toast.TYPE.SUCCESS,
            });
            callback(response);
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, FETCH_INVOICING_ERROR));
        });
};
export const fetchAccountingServiceInvoices = (batchNumber) => dispatch => {
    dispatch(setLoading(true));
    requestGetAccountingServiceInvoices(batchNumber)
        .then(response => {
            dispatch({
                type: FETCH_ACCOUNTING_SERVICE_INVOICES_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, FETCH_INVOICING_ERROR));
        });
};

export const fetchAccountingServiceInvoicesBatches = () => dispatch => {
    dispatch(setLoading(true));
    requestGetAccountingServiceInvoicesBatches()
        .then(response => {
            dispatch({
                type: FETCH_ACCOUNTING_SERVICE_INVOICES_BATCHES_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, FETCH_INVOICING_ERROR));
        });
};

export const fetchAccountingClientInvoicesBatches = () => dispatch => {
    dispatch(setLoading(true));
    requestGetAccountingClientInvoicesBatches()
        .then(response => {
            dispatch({
                type: FETCH_ACCOUNTING_CLIENT_INVOICES_BATCHES_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, FETCH_INVOICING_ERROR));
        });
};


export const exportAccountingServiceInvoices = (data, callback) => dispatch => {
    dispatch(setLoading(true));
    requestExportAccountingServiceInvoices(data)
        .then(response => {
            dispatch(setLoading(false));

            const fileName = "APServiceInvoices.txt";
            toast("Invoices list exported successfully", {
                type: toast.TYPE.SUCCESS,
            });
            callback();
            exportFromBlob(response.data, fileName);
        }).catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, FETCH_INVOICING_ERROR));
        });
};
export const fetchAccountingClientInvoices = (batchNumber) => dispatch => {
    dispatch(setLoading(true));
    requestGetAccountingClientInvoices(batchNumber)
        .then(response => {
            dispatch({
                type: FETCH_ACCOUNTING_CLIENT_INVOICES_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, FETCH_INVOICING_ERROR));
        });
};
export const exportAccountingReportExcel = (batchNumber) => dispatch => {
    dispatch(setLoading(true));
    requestReportExcel(batchNumber)
        .then(response => {
            dispatch(setLoading(false));
            const fileName = decodeURI(response.headers["content-disposition"].split("''")[1]) ||
                "ServiceInvoice.xlsx";
            toast("Service Invoice exported successfully", {
                type: toast.TYPE.SUCCESS,
            });
            exportFromBlob(response.data, fileName);
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, FETCH_INVOICING_ERROR));
        });
};

export const exportAccountingClientReportExcel = (batchNumber) => dispatch => {
		dispatch(setLoading(true));
		requestClientReportExcel(batchNumber)
				.then(response => {
						dispatch(setLoading(false));
						const fileName = decodeURI(response.headers["content-disposition"].split("''")[1]) ||
								"ClientInvoice.xlsx";
						toast("Client Invoice exported successfully", {
								type: toast.TYPE.SUCCESS,
						});
						exportFromBlob(response.data, fileName);
				})
				.catch(error => {
						dispatch(setLoading(false));
						dispatch(defaultErrorHandler(error, FETCH_INVOICING_ERROR));
				});
};


export const exportAccountingClientInvoices = (data, callback) => dispatch => {
    dispatch(setLoading(true));
    requestExportAccountingClientInvoices(data)
        .then(response => {
            dispatch(setLoading(false));
            const fileName = "CustomerServiceInvoices.txt";
            toast("Invoices list exported successfully", {
                type: toast.TYPE.SUCCESS,
            });
            callback();
            exportFromBlob(response.data, fileName);
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, FETCH_INVOICING_ERROR));
        });
};
export const exportAccountingActiveJobs = () => dispatch => {
    dispatch(setLoading(true));
    requestExportAccountingActiveJobs()
        .then(async response => {
            dispatch(setLoading(false));
            const fileName = "ActiveJobList.txt";
            toast("Active Job list exported successfully", {
                type: toast.TYPE.SUCCESS,
            });
            exportFromBlob(response.data, fileName);
            // acceptExport();
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, FETCH_INVOICING_ERROR));
        });
};
export const setMissingMerchandiserLoading = (loading) => dispatch => {
    dispatch({
        type: FETCH_MISSING_MERCHANDISER_CHARGES_LOADING,
        payload: loading
    });
};
export const getMissingMerchandiserCharges = (fromDate) => dispatch => {
    dispatch(setMissingMerchandiserLoading(true));
    requestGetMissingMerchandiserCharges(fromDate)
        .then(response => {
            dispatch({
                type: FETCH_MISSING_MERCHANDISER_CHARGES_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(setMissingMerchandiserLoading(false));
            dispatch(defaultErrorHandler(error, FETCH_INVOICING_ERROR));
        });
};

export const createMerchandiserCharges = (data, callback) => dispatch => {
    dispatch(setMissingMerchandiserLoading(true));
    requestCreateMerchandiserCharges(data)
        .then(() => {
            toast("Created successfully", {
                type: toast.TYPE.SUCCESS,
            });
            dispatch(setMissingMerchandiserLoading(false));
            callback();
        })
        .catch(error => {
            dispatch(setMissingMerchandiserLoading(false));
            dispatch(defaultErrorHandler(error, FETCH_INVOICING_ERROR));
        });
};
export const setMissingClientLoading = (loading) => dispatch => {
    dispatch({
        type: FETCH_MISSING_CLIENT_CHARGES_LOADING,
        payload: loading
    });
};
export const fetchMissingClientCharges = (fromDate) => dispatch => {
    dispatch(setMissingClientLoading(true));
    requestGetMissingClientCharges(fromDate)
        .then(response => {
            dispatch({
                type: FETCH_MISSING_CLIENT_CHARGES_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(setMissingClientLoading(false));
            dispatch(defaultErrorHandler(error, FETCH_INVOICING_ERROR));
        });
};

export const createClientCharges = (data, callback) => dispatch => {
    dispatch(setMissingClientLoading(true));
    requestCreateClientCharges(data)
        .then(() => {
            toast("Created successfully", {
                type: toast.TYPE.SUCCESS,
            });
            dispatch(setMissingClientLoading(false));
            callback();
        })
        .catch(error => {
            dispatch(setMissingClientLoading(false));
            dispatch(defaultErrorHandler(error, FETCH_INVOICING_ERROR));
        });
};

export const processAutoTravelCharges = (date, callback) => dispatch => {
    dispatch(setLoading(true));
    requestProcessAutoTravelCharges(date)
        .then(() => {
            dispatch(setLoading(false));
            toast("Daily travel charges processed successfully", {
                type: toast.TYPE.SUCCESS,
            });
            if (callback) {
                callback();
            }
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, FETCH_INVOICING_ERROR));
        });
};
